<template>
    <div>
        <div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-search"></i><span>档案检索</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- <el-divider></el-divider> -->

        <div class="container" style="height: 98%;">
            <el-tabs v-model="retrievalTabs">
                <el-tab-pane label="模糊查找" name="1" class="fuzzy-search-tab">
                    <div style="margin: 4% 5% 14% 5%;">
                        <div style="text-align: center;">
                            <el-row>
                                <img src="../../../assets/img/DGJLogo.png" width="17%">
                            </el-row>
                            <el-row style="margin-top: 3%;">
                                <el-form :model="findAllForm" ref="findAllForm">
                                    <el-input v-model="findAllForm.queryWord" prefix-icon="el-icon-search" style="width: 60%;" @keyup.enter.native="fuzzySearchClickFun()">
                                        <el-button slot="append" type="primary" style="width: 100px;" @click="fuzzySearchClickFun()">找一找</el-button>
                                    </el-input>
                                </el-form>
                            </el-row>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="找文件" name="2">
                    <el-form :model="findFileForm" ref="findFileForm" style="width: 98%;">
                        <div style="margin-bottom: 15px;">
                            <span class="ar-title">上传信息</span>
                            <div style="margin: 10px 0px 0px 0px;">
                                <div style="display: flex;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>批次号</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="batchNo">
                                                <el-input v-model="findFileForm.batchNo" placeholder="单行输入"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>原文件名</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="oriFileName">
                                                <el-input v-model="findFileForm.oriFileName" placeholder="单行输入"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>文件号</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="fileNo">
                                                <el-input v-model="findFileForm.fileNo" placeholder="单行输入"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>所属实体</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="companyId">
                                                <el-select v-model="findFileForm.companyId" placeholder="请选择" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in userRelCompanyData"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>上传人</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="operator">
                                                <el-input v-model="findFileForm.operator" placeholder="单行输入"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-bottom: 15px;">
                            <span class="ar-title">文件内容</span>
                            <div style="margin: 10px 0px 0px 0px;">
                                <div style="display: flex;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>文件类型</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="fileType">
                                                <el-select v-model="findFileForm.fileType" placeholder="请选择" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in fileTypeData"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>凭证类型</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="voucherType">
                                                <el-select v-model="findFileForm.voucherType" placeholder="请选择" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in voucherTypeData"
                                                        :key="item.code"
                                                        :label="item.title"
                                                        :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>凭证号码</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="voucherNo">
                                                <el-input v-model="findFileForm.voucherNo" placeholder="单行输入"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>凭证日期</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findFileForm.voucherDateStart" type="date" placeholder="开始日期" style="width:47%" value-format="yyyy-MM-dd"></el-date-picker>
                                                <span style="line-height: 32px;width:6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findFileForm.voucherDateEnd" type="date" placeholder="结束日期" style="width:47%" value-format="yyyy-MM-dd"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;" v-if="!this.findFileForm.voucherType || this.findFileForm.voucherType == 0">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>一级科目</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="firstLevelAccount">
                                                <el-input v-model="findFileForm.firstLevelAccount" placeholder="输入编号、描述都可以反显"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>明细科目</label>
                                            </div>
                                            <el-form-item class="ar-form-input" prop="detailAccount">
                                                <el-input v-model="findFileForm.detailAccount" placeholder="输入编号、描述都可以反显"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>凭证金额</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findFileForm.voucherAmountStart" placeholder="最小金额" style="width:47%"></el-input>
                                                <span style="line-height: 32px;width:6%;text-align: center;"> - </span>
                                                <el-input v-model="findFileForm.voucherAmountEnd" placeholder="最大金额" style="width:47%"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-bottom: 15px;">
                            <span class="ar-title">文件状态</span>
                            <div style="margin: 10px 0px 0px 0px;">
                                <div style="margin-left: 4%;display: flex;">
                                    <div class="voucher-img-div" v-for="(imgObj, index) in fileStatusImgList" :key="index">
                                        <img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="fileStatusImgClickFun($event, index)">
                                    </div>
                                </div>
                                <div style="margin-left: 4%;margin-top:10px">
                                    <el-checkbox v-model="fi_checked" @change="changeFiAll">全选</el-checkbox>
                                </div>
                            </div>
                        </div>
                        <div style="text-align: center;">
                            <el-button type="primary" style="width: 80px;margin-right: 100px;" @click="findFileClickFun()">查找</el-button>
                            <el-button style="width: 80px;" @click="resetForm('findFileForm')" plain>重置</el-button>
                        </div>  
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="找组" name="3">
                    <el-form :model="findGroupForm">
                        <div style="margin-bottom: 15px;">
                            <div style="margin: 10px 0px 0px 0px;">
                                <div style="display: flex;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>操作人</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findGroupForm.operator" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>最近操作时间</label>
                                            </div>
                                             <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findGroupForm.startTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" style="width: 47%;"></el-date-picker>
                                                <span style="line-height: 32px;width:6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findGroupForm.endTime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" style="width: 47%;"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                    </div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>所属实体</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findGroupForm.companyName" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>组号</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findGroupForm.groupNo" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>文件类型</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-select v-model="findGroupForm.fileType" placeholder="请选择" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in fileTypeData"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>组内凭证号</label>
                                            </div>
                                             <div class="ar-form-input">
                                                <el-input v-model="findGroupForm.voucherNo" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-left: 25%;margin-top: 15px;">
                            <el-button type="primary" style="width: 80px;margin-right: 100px;" @click="findGroupClickFun()">查找</el-button>
                            <el-button style="width: 80px;">重置</el-button>
                        </div>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="找册子" name="4">
                    <el-form :model="findBookForm" style="width: 98%;">
                        <!-- <div style="margin-bottom: 15px;">
                            <span class="ar-title">上架信息</span>
                            <div style="margin: 10px 0px 0px 0px;">
                                <div style="display: flex;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>是否上架</label>
                                            </div>
                                            <div class="ar-form-input" style="line-height: 32px;">
                                                <el-radio v-model="findBrochureForm.sfsj" label="1">是</el-radio>
                                                <el-radio v-model="findBrochureForm.sfsj" label="2">否</el-radio>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>上架时间</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findBrochureForm.sjsjStart" type="date" placeholder="开始时间" style="width: 47%;"></el-date-picker>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findBrochureForm.sjsjEnd" type="date" placeholder="结束时间" style="width: 47%;"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>库房编号</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.kfbhStart" style="width: 47%;" placeholder="库房编号（开始）"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.kfbhEnd" style="width: 47%;" placeholder="库房编号（结束）"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>架子编号</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.jzbhStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.jzbhEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div style="margin-bottom: 15px;">
                            <div style="margin: 10px 0px 0px 0px;">
                                <div style="display: flex;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>成册类别</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-select v-model="findBrochureForm.cclb" placeholder="请选择" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in fileTypeData"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>单位名称</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBrochureForm.dwmc" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>凭证名称</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBrochureForm.pzmc" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>统计期间</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findBrochureForm.tjqjStart" type="date" placeholder="开始期间" style="width: 47%;"></el-date-picker>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findBrochureForm.tjqjEnd" type="date" placeholder="结束期间" style="width: 47%;"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>总册数</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.zcsStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.zcsEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>本册次</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.bccStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.bccEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>记账凭证号</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.jzpzhStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.jzpzhEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>记账凭证数</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.jzpzsStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.jzpzsEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>附件数</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBrochureForm.fjsStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBrochureForm.fjsEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>备注</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBrochureForm.bz" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>会计主管</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBrochureForm.kjzg" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>装订人</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBrochureForm.zdr" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>装订时间</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findBrochureForm.zdsjStart" type="date" placeholder="开始时间" style="width: 47%;"></el-date-picker>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findBrochureForm.zdsjEnd" type="date" placeholder="结束时间" style="width: 47%;"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                            </div>
                        </div> -->

                        <!-- 册子v2表单 -->
                        <div style="margin-bottom: 15px;">
                              <div style="margin: 10px 0px 0px 0px;">
                                <div style="display: flex;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>成册类别</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-select v-model="findBookForm.cclb" placeholder="请选择" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in fileTypeData"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>所属实体</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBookForm.ssst" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>册号</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBookForm.ch" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>统计期间</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findBookForm.tjqjStart" type="date" placeholder="开始期间" value-format="yyyy-MM-dd" style="width: 47%;"></el-date-picker>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findBookForm.tjqjEnd" type="date" placeholder="结束期间" value-format="yyyy-MM-dd" style="width: 47%;"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>记账凭证份数</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBookForm.jzpzfsStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBookForm.jzpzfsEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>附件数</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-input v-model="findBookForm.fjsStart" style="width: 47%;" placeholder="单行输入"></el-input>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-input v-model="findBookForm.fjsEnd" style="width: 47%;" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                                <div style="display: flex;margin-top: 15px;">
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>成册人</label>
                                            </div>
                                            <div class="ar-form-input">
                                                <el-input v-model="findBookForm.ccr" placeholder="单行输入"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item">
                                        <div style="display: flex;">
                                            <div class="ar-form-label">
                                                <label>成册时间</label>
                                            </div>
                                            <div class="ar-form-input" style="display: flex;">
                                                <el-date-picker v-model="findBookForm.ccsjStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd" style="width: 47%;"></el-date-picker>
                                                <span style="line-height: 32px;width: 6%;text-align: center;"> - </span>
                                                <el-date-picker v-model="findBookForm.ccsjEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd" style="width: 47%;"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ar-form-item"></div>
                                </div>
                              </div>
                        </div>
                        <div style="text-align: center;margin-top: 15px;">
                            <el-button type="primary" style="width: 80px;margin-right: 100px;" @click="findBookClickFun()">查找</el-button>
                            <el-button style="width: 80px;">重置</el-button>
                        </div>  
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import https, { fetchGet, fetchPost } from '../../../../https.js';
export default {
    name: 'basetable',
    data() {
        return {
            retrievalTabs: '1', // 默认选中tab页
            fileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),   //  文件状态
            fileTypeData: JSON.parse(JSON.stringify(this.fileTypeList)),    //  文件类型：默认会计凭证不能修改
            voucherTypeData: [],
            userRelCompanyData: [],
            findAllForm:{
                queryWord: '',
            },
            findFileForm: {
                batchNo: '',
                oriFileName: '',
                fileNo: '',
                companyId: '',
                operator: '',
                fileType: '1',   //  文件类型：默认会计凭证
                voucherType: '-1',   //  凭证类型：默认所有
                voucherNo: '',
                voucherDateStart: '',
                voucherDateEnd: '',
                firstLevelAccount: '',
                detailAccount: '',
                voucherAmountStart: '',
                voucherAmountEnd: ''
            },
            findGroupForm: {
                operator: '',
                czsjStart: '',
                czsjEnd: '',
                companyName: '',
                groupNo: '',
                fileType: '',
                voucherNo: '',
                startTime:'',
                endTime:''
            },
            // findBrochureForm: {
            //     sfsj: '',
            //     sjsjStart: '',
            //     sjsjEnd: '',
            //     sjwzStart: '',
            //     sjwzEnd: '',
            //     jzbhStart: '',
            //     jzbhEnd: '',
            //     cclb: '',
            //     dwmc: '',
            //     pzmc: '',
            //     tjqjStart: '',
            //     tjqjEnd: '',
            //     zcsStart: '',
            //     zcsEnd: '',
            //     bccStart: '',
            //     bccEnd: '',
            //     jzpzhStart: '',
            //     jzpzhEnd: '',
            //     jzpzsStart: '',
            //     jzpzhEnd: '',
            //     jzpzsStart: '',
            //     jzpzsEnd: '',
            //     fjsStart: '',
            //     fjsEnd: '',
            //     bz: '',
            //     kjzg: '',
            //     zdr: '',
            //     zdsjStart: '',
            //     zdsjEnd: ''
            // },
            findBookForm: {
                cclb:'',
                ssst:'',
                tjqjStart:'',
                tjqjEnd:'',
                ch:'',
                jzpzfsStart:'',
                jzpzfsEnd:'',
                fjsStart:'',
                fjsEnd:'',
                ccr:'',
                ccsjStart:'',
                ccsjEnd:''
            },
            fileStatus: [],
            search: '',
            fi_checked:true,

        }
    },
    created: function() {
        if(this.$route.params && this.$route.params.searchTabVal) {
            this.retrievalTabs = this.$route.params.searchTabVal;
        }

        this.voucherTypeData = JSON.parse(JSON.stringify(this.accountingVoucherTypeList)).concat(JSON.parse(JSON.stringify(this.originalvoucherTypeList)));
        this.voucherTypeData.unshift({'title': '所有', 'code': '-1'});
    },
    methods: {
        fileStatusImgClickFun(event, index) {	//	文件状态点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this.fileStatusImgList[index].name = imgName + '-h';
			} else {
				this.fileStatusImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}
		},
        resetForm(formName) {   //  form 重置
            this.$refs[formName].resetFields();
            if(formName == 'findFileForm') {
                this[formName].voucherDateStart = "";
                this[formName].voucherDateEnd = "";
                this[formName].voucherAmountStart = "";
                this[formName].voucherAmountEnd= "";
            }
        },
        findFileClickFun() {    //  找文件 - 查找
            let voucherDateStart = this.findFileForm.voucherDateStart;
            let voucherDateEnd = this.findFileForm.voucherDateEnd;
            let voucherAmountStart = this.findFileForm.voucherAmountStart;
            let voucherAmountEnd = this.findFileForm.voucherAmountEnd;
            if(voucherDateStart && voucherDateEnd && voucherDateStart > voucherDateEnd) {
                this.$message.warning('凭证结束日期不能早于凭证开始日期！');
                return;
            }
            if(voucherAmountStart && voucherAmountEnd && voucherAmountStart > voucherAmountEnd) {
                this.$message.warning('凭证最大金额不能小于凭证最小金额！');
                return;
            }
            this.findFileData().then(findFileData => {
                this.$router.push({ name: 'archivesRetrievalFuzzySearch', params: { findFileData: findFileData,searchType:2, searchTabVal: this.retrievalTabs }});
            });
        },
        async findFileData() {
            let findFileData = [];
            //  获取勾选文件状态 list
			let checkFileStatusList = [];
			let fileStatusImgList = this.fileStatusImgList;
			fileStatusImgList.forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkFileStatusList.push(statusObj.code);
				}
            });
            this.findFileForm.fileStatus = checkFileStatusList.join(',');
            await fetchPost('/archival/retrieval/getFindFileList', this.findFileForm).then(res => {
                if(res.data.success) {
                    findFileData = res.data.obj;
                } else {
                    this.$message.error('找文件失败：' + res.data.success);
                }
            }, error => {
                this.$message.error('找文件失败：' + error);
            });
            return findFileData;
        },
        //模糊查询:
        fuzzySearchClickFun() {
            this.findAllData().then(findFileData => {
                 this.$router.push({ name: 'archivesRetrievalFuzzySearch', params: { findFileData: findFileData,searchType:1, searchTabVal: this.retrievalTabs }})
            });
        },
        async findAllData() {
            let findAll = [];
            await fetchGet('/search/getAllSearchList', this.findAllForm).then(res => {
                if(res.data.success) {
                    findAll = res.data.data;
                } else {
                    this.$message.error('模糊搜索失败' + res.data.msg);
                }
            }, error => {
                this.$message.error('模糊搜索失败' + error);
            });
            return findAll;
        },

        //查找- 组
        findGroupClickFun(){
           let czsjStart =  this.findGroupForm.startTime;
           let czsjEnd =  this.findGroupForm.endTime;
           if(czsjStart && czsjEnd && czsjStart > czsjEnd) {
                this.$message.warning('操作时间结束日期不能早于操作时间开始日期！');
                return;
            }
            this.findGroupData().then(findFileData => {
                this.$router.push({ name: 'archivesRetrievalFuzzySearch', params: { findFileData: findFileData,searchType:3, searchTabVal: this.retrievalTabs }});
            });
            
        },
        async findGroupData() {
            let findGroupData = [];
            await fetchPost('/archival/retrieval/getFindGroupList', this.findGroupForm).then(res => {
                if(res.data.success) {
                    findGroupData = res.data.obj;
                } else {
                    this.$message.error('找组失败' + res.data.success);
                }
            }, error => {
                this.$message.error('找组失败' + error);
            });
            return findGroupData;
        },
        //找册子
        findBookClickFun(){

            let tjqjStart =  this.findBookForm.tjqjStart;
            let tjqjEnd =  this.findBookForm.tjqjEnd;
            let ccsjStart =  this.findBookForm.ccsjStart;
            let ccsjEnd =  this.findBookForm.ccsjEnd;

           if(tjqjStart && tjqjEnd && tjqjStart > tjqjEnd) {
                this.$message.warning('统计期间结束日期不能早于统计期间开始日期！');
                return;
            }
            if(ccsjStart && ccsjEnd && ccsjStart > ccsjEnd) {
                this.$message.warning('成册时间结束日期不能早于成册时间开始日期！');
                return;
            }
            this.findBookData().then(findFileData => {
                this.$router.push({ name: 'archivesRetrievalFuzzySearch', params: { findFileData: findFileData,searchType:4, searchTabVal: this.retrievalTabs }});
            });
            
        },
        async findBookData() {
            let findBookData = [];
            await fetchPost('/archival/retrieval/getFindBookList', this.findBookForm).then(res => {
                if(res.data.success) {
                    findBookData = res.data.obj;
                } else {
                    this.$message.error('找组失败' + res.data.success);
                }
            }, error => {
                this.$message.error('找组失败' + error);
            });
            return findBookData;
        },
        changeFiAll(event){
            if(!event){
				this.fi_checked = false;
				this.fileStatusImgList.forEach(statusObj => {
                    if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
                        statusObj.name = statusObj.name + '-h';
                    }
				});
			}else{
				this.fi_checked = true;
				this.fileStatusImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
						statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
					}
				});
			}
        }


    },
    watch: {
        'retrievalTabs': function(val) {
            if(val == '2') {
                this.getUserBeLongsCompanyList().then(companyList => {
                    companyList.unshift({'id': '-1', 'name': '所有'});
                   this.userRelCompanyData = companyList;
                   if(companyList && companyList.length > 0) {
                       this.findFileForm.companyId = companyList[0].id;
                   } 
                });
            }
        }
    }
}
</script>

<style scoped>
    /* 模糊查找-input框高度 */
    .fuzzy-search-tab .el-input--small /deep/ .el-input__inner {
        height: 50px !important;
        line-height: 50px !important;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1) !important;
    }
    /* 模糊查找 - 搜索图标 */
    .fuzzy-search-tab .el-input--small /deep/ .el-input__icon {
        line-height: 50px;
        font-size: 20px;
        padding-left: 20px;
    }
    .fuzzy-search-tab .el-input--prefix /deep/ .el-input__inner {
        padding-left: 60px;
    }
    .fuzzy-search-tab /deep/ .el-input-group__append, .el-input-group__prepend {
        background-color: #409EFF;
        color: #ffffff;
        font-size: 16px;
    }
    </style>